const BG = { yellow: "var(--yellow)", blue: "var(--blue)", pink: "var(--pink)", green: "var(--green)", orange: "var(--orange)", purple: "var(--purple)" };

export const Slate = ({ title, sub, color = "yellow", className = "" }) => (
  <div className={`slate ${className}`} style={{ background: BG[color] }} data-testid="slate-thumb">
    <div className="text-center px-6 pt-6" style={{ color: color === "blue" || color === "orange" ? "#fff" : "var(--ink)" }}>
      <div className="font-mono text-[0.6rem] tracking-[0.3em] uppercase opacity-70">scene · take 01</div>
      <div className="pixel-title text-2xl md:text-4xl mt-2 leading-none">{title}</div>
      {sub && <div className="font-hand text-xl md:text-2xl mt-2 opacity-80">{sub}</div>}
    </div>
  </div>
);

export const Thumb = ({ item, className = "" }) =>
  item.slate ? (
    <Slate title={item.title} sub={item.sub || item.date} color={item.color || "yellow"} className={className} />
  ) : (
    <img src={item.thumb} alt={item.title} loading="lazy" className={className} />
  );
